import React from 'react';
import MessagesComponent from '../Dashboard/Components/Messages/Messages';

const Messages = React.memo(() => {
  return <MessagesComponent />;
});

Messages.displayName = 'Messages';

export default Messages;
